/**
 * phone.js — اشتقاق رابط واتساب من رقم جوال: **نسخةٌ واحدة** (v14.77)
 * ═══════════════════════════════════════════════════════════════════════════
 * 🔴 لماذا وُحِّد: النمط كان منسوخاً في الشاشات بصيغةٍ واحدة تصحّ لحالةٍ واحدة:
 *       `https://wa.me/966${phone.replace(/^0/, '')}`
 *    فهي تعمل مع `05…` فقط، وتُخرج رابطاً معطوباً لكل ما عداها:
 *      • `+9665…`  ⇐ `wa.me/966+9665…`
 *      • `00966…`  ⇐ `wa.me/96600966…`
 *      • `٠٥٥…`    ⇐ يخرج بالأرقام العربية كما هو
 *      • `9665…`   ⇐ `wa.me/9669665…`
 *
 * 🪤 والرابط المعطوب **لا يُخطئ ولا يُسجَّل**: واتساب يفتح ويقول «الرقم غير
 *    صالح»، فيستنتج صاحبُ اللوحة أن العميل ليس على واتساب — والخطأ في الرابط.
 *    ولذلك تُرجع الدالّة فراغاً حين لا تستطيع اشتقاق رقمٍ سليم، ويُخفي المكوّن
 *    الزرَّ عندها: لا زرّ خيرٌ من زرٍّ يقود إلى خطأ.
 *
 * ℹ️ السعودية: `9665XXXXXXXX` (مفتاح ٩٦٦ + ٥ + ثماني خانات). وما جاء بمفتاح
 *    دولةٍ أخرى يُمرَّر كما هو — إخفاء وسيلة تواصلٍ صالحة أسوأ من تمريرها.
 */

const AR_DIGITS = '٠١٢٣٤٥٦٧٨٩';
const FA_DIGITS = '۰۱۲۳۴۵۶۷۸۹';

/** أرقام عربية/فارسية ⇐ لاتينية. (لوحة المفاتيح العربية تُخرجها كثيراً.) */
function toLatinDigits(s) {
    let out = '';
    for (const ch of String(s == null ? '' : s)) {
        const a = AR_DIGITS.indexOf(ch);
        if (a >= 0) { out += String(a); continue; }
        const f = FA_DIGITS.indexOf(ch);
        if (f >= 0) { out += String(f); continue; }
        out += ch;
    }
    return out;
}

/**
 * الرقم بصيغة واتساب الدولية (بلا `+`)، أو `''` إن تعذّر.
 * @param {string|null|undefined} raw
 * @returns {string}
 */
function waNumber(raw) {
    let d = toLatinDigits(raw).replace(/\D/g, '');
    if (!d) return '';
    if (d.startsWith('00')) d = d.slice(2);

    if (d.startsWith('966')) {
        // `9660 5…` يقع عند لصق «+966» أمام رقمٍ محلّي كامل — الصفر يُسقَط.
        d = '966' + d.slice(3).replace(/^0+/, '');
    } else if (d.startsWith('0')) {
        d = '966' + d.replace(/^0+/, '');
    } else if (/^5\d{8}$/.test(d)) {
        d = '966' + d;                      // رقمٌ محلّي بلا صفر ولا مفتاح
    }

    if (/^9665\d{8}$/.test(d)) return d;
    // مفتاح دولةٍ أخرى — يُمرَّر كما هو (وليس 966 مشوّهاً).
    if (!d.startsWith('966') && /^\d{10,15}$/.test(d)) return d;
    return '';
}

/** رابط `wa.me` جاهز، أو `''` إن كان الرقم غير صالح. */
function waLink(raw) {
    const n = waNumber(raw);
    return n ? 'https://wa.me/' + n : '';
}

module.exports = { waLink, waNumber, toLatinDigits };
